let szenedata = 2;
import { sitePos } from "./sitepos";

sitePos(szenedata);